import { IconButton } from "@mui/material";
import CloseIcon from "../../gui/Icons/CloseIcon";

export default function DialogTitle(props:{title:string, onClose:(e:any)=>void}) {
    return <div className="heading">
        <h2>{props.title}</h2>
        <IconButton onClick={props.onClose} className="close"><CloseIcon/></IconButton>
    </div>    
}